import { CALL_API } from "redux-api-middleware";
import { api } from "apis/account";
import {
  REQUEST_CLOCK_IN,
  RECEIVE_CLOCK_IN,
  ERROR_CLOCK_IN,
  REQUEST_CLOCK_OUT,
  RECEIVE_CLOCK_OUT,
  ERROR_CLOCK_OUT,
  REQUEST_CURRENT_CLOCK,
  RECEIVE_CURRENT_CLOCK,
  ERROR_CURRENT_CLOCK,
  REQUEST_TIMECLOCK_PAYPERIOD,
  RECEIVE_TIMECLOCK_PAYPERIOD,
  ERROR_TIMECLOCK_PAYPERIOD,
  REQUEST_ADD_TIMECLOCK,
  RECEIVE_ADD_TIMECLOCK,
  ERROR_ADD_TIMECLOCK,
  REQUEST_DELETE_TIMECLOCK,
  RECEIVE_DELETE_TIMECLOCK,
  ERROR_DELETE_TIMECLOCK,
  REQUEST_UPDATE_TIMECLOCK,
  RECEIVE_UPDATE_TIMECLOCK,
  ERROR_UPDATE_TIMECLOCK,
  REQUEST_EMPLOYEES_BY_PAYPERIOD,
  RECEIVE_EMPLOYEES_BY_PAYPERIOD,
  CLEAR_EMPLOYEES_BY_PAYPERIOD,
  ERROR_EMPLOYEES_BY_PAYPERIOD,
  REQUEST_APPROVE_USER_PAYPERIOD,
  RECEIVE_APPROVE_USER_PAYPERIOD,
  ERROR_APPROVE_USER_PAYPERIOD,
  SET_MIDNIGHT,
  REQUEST_QA_EMPLOYEES_BY_PAYPERIOD,
  RECEIVE_QA_EMPLOYEES_BY_PAYPERIOD,
  CLEAR_QA_EMPLOYEES_BY_PAYPERIOD,
  ERROR_QA_EMPLOYEES_BY_PAYPERIOD,
} from "typeConstants";
import responseHandler from "responseHandler";
import { HTTP_GET, HTTP_POST, HTTP_PUT, HTTP_DELETE } from "tools/webservice";

const clockIn = (timeZoneOffset, clockInOutOverride = null) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.clockIn(),
        method: HTTP_POST,
        body: JSON.stringify({ 
          timeZoneOffsetMinutes: timeZoneOffset,
          clockInOutOverride: clockInOutOverride
        }),
        types: [
          REQUEST_CLOCK_IN,
          {
            type: RECEIVE_CLOCK_IN,
            payload: (action, state, res) =>
              res.json().then(data => {
                dispatch(setMidnight());
                return data;                
              })
          },
          {
            type: ERROR_CLOCK_IN,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const clockOut = (timeZoneOffset, clockInOutOverride = null, callback = null) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.clockOut(),
        method: HTTP_POST,
        body: JSON.stringify({ 
          timeZoneOffsetMinutes: timeZoneOffset,
          clockInOutOverride: clockInOutOverride
        }),
        types: [
          REQUEST_CLOCK_OUT,
          {
            type: RECEIVE_CLOCK_OUT,
            payload: (action, state, res) =>
              res.json().then(data => {
                if(callback) callback(data);                
                dispatch(resetMidnight());
                return data;
              })
          },
          {
            type: ERROR_CLOCK_OUT,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getActiveClock = timeZoneOffsetMinutes => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.activeClock(timeZoneOffsetMinutes),
        method: HTTP_GET,
        types: [
          REQUEST_CURRENT_CLOCK,
          {
            type: RECEIVE_CURRENT_CLOCK,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_CURRENT_CLOCK,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getTimeClockByPayPeriod = (internetUserId, payPeriodId) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.getTimeClockByPayPeriod(internetUserId, payPeriodId),
        method: HTTP_GET,
        types: [
          REQUEST_TIMECLOCK_PAYPERIOD,
          {
            type: RECEIVE_TIMECLOCK_PAYPERIOD,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_TIMECLOCK_PAYPERIOD,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const addTimeClock = (internetUserId, dto) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.addTimeClock(internetUserId),
        method: HTTP_POST,
        body: JSON.stringify(dto),
        types: [
          REQUEST_ADD_TIMECLOCK,
          {
            type: RECEIVE_ADD_TIMECLOCK,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_ADD_TIMECLOCK,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const deleteTimeClock = id => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.deleteTimeClock(id),
        method: HTTP_DELETE,
        types: [
          REQUEST_DELETE_TIMECLOCK,
          {
            type: RECEIVE_DELETE_TIMECLOCK,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_DELETE_TIMECLOCK,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const updateTimeClock = (id, clockIn, clockOut) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.updateTimeClock(id),
        method: HTTP_PUT,
        body: JSON.stringify({
          clockInDateTime: clockIn,
          clockOutDateTime: clockOut
        }),
        types: [
          REQUEST_UPDATE_TIMECLOCK,
          {
            type: RECEIVE_UPDATE_TIMECLOCK,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_UPDATE_TIMECLOCK,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getEmployeesByPayPeriod = (internetUserId, payPeriodId, roles) => {
  return function (dispatch) {
    if (payPeriodId === 0) {
      // payPeriodId === 0 clears the current list of employees
      dispatch({
        type: CLEAR_EMPLOYEES_BY_PAYPERIOD,
        payload: []
      });
    }
    else
      dispatch({
        [CALL_API]: {
          endpoint: api.getEmployeesByPayPeriod(internetUserId, payPeriodId, roles),
          method: HTTP_POST,
          body: JSON.stringify(roles),
          types: [
            REQUEST_EMPLOYEES_BY_PAYPERIOD,
            {
              type: RECEIVE_EMPLOYEES_BY_PAYPERIOD,
              payload: (action, state, res) =>
                res.json().then(data => {
                  return data;
                })
            },
            {
              type: ERROR_EMPLOYEES_BY_PAYPERIOD,
              payload: (action, state, res) => {
                responseHandler.error(res, dispatch);
              }
            }
          ]
        }
      });
  };
};
const approvePayPeriodUser = (payPeriodId, internetUserId) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.approvePayPeriodUser(payPeriodId, internetUserId),
        method: HTTP_PUT,
        types: [
          REQUEST_APPROVE_USER_PAYPERIOD,
          {
            type: RECEIVE_APPROVE_USER_PAYPERIOD,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_APPROVE_USER_PAYPERIOD,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const setMidnight = () => {
  const midnight = new Date(); 
  midnight.setHours(24, 0, 0, 0);        
  return dispatch => {
    dispatch({
      type: SET_MIDNIGHT,
      payload: midnight
    });
  };
};

const resetMidnight = () => {
  return dispatch => {
    dispatch({
      type: SET_MIDNIGHT,
      payload: null
    });
  };
};

// This action uses the same redux state values as getEmployeesByPayPeriod above but gets data from a different end point
const getQaEmployeesByPayPeriod = (internetUserId, payPeriodId, traineeFilterOption = null, statusFilterOption = null) => {
  let endpoint = `/qa/managers/${internetUserId}/payperiods/${payPeriodId}/employees`;
  let queryParams = [
    {
      filterName: "traineeFilterOption",
      filterValue: traineeFilterOption
    },
    {
      filterName: "statusFilterOption",
      filterValue: statusFilterOption
    }
  ];
  queryParams = queryParams.filter(param => param.filterValue !== null);
  if (queryParams.length > 0) {
    endpoint += "?";
    endpoint += queryParams.map((param) => {
      return `${param.filterName}=${param.filterValue}`;
    }).join("&");
  }
  return function (dispatch) {
    if (payPeriodId === 0) {
      // payPeriodId === 0 clears the current list of employees
      dispatch({
        type: CLEAR_QA_EMPLOYEES_BY_PAYPERIOD,
        payload: []
      });
    }
    else
      dispatch({
        [CALL_API]: {
          endpoint,
          method: HTTP_GET,
          types: [
            REQUEST_QA_EMPLOYEES_BY_PAYPERIOD,
            {
              type: RECEIVE_QA_EMPLOYEES_BY_PAYPERIOD,
              payload: (action, state, res) =>
                res.json().then(data => {
                  return data;
                })
            },
            {
              type: ERROR_QA_EMPLOYEES_BY_PAYPERIOD,
              payload: (action, state, res) => {
                responseHandler.error(res, dispatch);
              }
            }
          ]
        }
      });
  };
};

export {
  clockIn,
  clockOut,
  getActiveClock,
  getTimeClockByPayPeriod,
  addTimeClock,
  deleteTimeClock,
  updateTimeClock,
  getEmployeesByPayPeriod,
  approvePayPeriodUser,
  setMidnight,
  resetMidnight,
  getQaEmployeesByPayPeriod,
};